import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'app/components';

import EventDecription from '../../../event-create/components/step-1/eventDescription'

const Description = (props) => {
  const {
    formData,
    onChange,
    readOnly,
  } = props;

  const [data, setData] = useState(formData);
  const { activeRequests } = useSelector((state) => state.app);
  const [ loading, setLoading ] = useState(false);

  useEffect(() => {
    if (activeRequests?.includes('save-event')) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [activeRequests]);

  useEffect(() => {
    setData(formData);
  }, [formData]);

  const handleSave = () => {
    onChange(data, 'Saved');
  };

  return (
    <div className='h-full pt-[36px] px-[80px] flex flex-col gap-9'>
      <h1 className='heading-24'>Event Description</h1>
      <div className='flex flex-col'>
        <EventDecription
          showHeader={false}
          setFormData={setData}
          formData={data}
          disabled={readOnly}
        />
      </div>
      <Button type='primary'
        onClick={handleSave}
        disabled={readOnly}
        loading={loading}
        className="mt-auto mb-4 flex self-center">
          Save
      </Button>
    </div>
  );
};

export default Description;
